<template>
    <article class="collapsible">
        <header
            class="collapsible__header"
            role="heading"
            @click="toggleIsExpanded">
            <h2>{{ heading }}</h2>
            <button
                class="collapsible__button"
                type="button"
                :aria-expanded="isExpanded"
                :aria-label="isExpanded ? 'Collapse': 'Expand'">
                <span
                    class="collapsible__icon"
                    :class="iconClass"></span>
            </button>
        </header>
        <transition
            v-on:before-enter="collapse"
            v-on:before-leave="expand"
            v-on:enter="expand"
            v-on:leave="collapse">
            <div
                class="collapsible__body"
                role="region"
                v-show="isExpanded"
                v-html="bodyHtml"
                :aria-hidden="!isExpanded"></div>
        </transition>
    </article>
</template>

<script>
export default {
    computed: {
        iconClass () {
            return this.isExpanded ? 'icon-chevron-lg-up' : 'icon-chevron-lg-down'
        }
    },
    data () {
        return {
            isExpanded: false
        }
    },
    methods: {
        collapse: function (el) {
            el.style.height = '0'
        },
        expand: function (el) {
            el.style.height = `${el.scrollHeight}px`
        },
        toggleIsExpanded () {
            this.isExpanded = !this.isExpanded
        }
    },
    props: {
        bodyHtml: {
            default: '',
            required: true,
            type: String
        },
        heading: {
            default: '',
            required: true,
            type: String
        }
    }
}
</script>

<style lang="postcss" scoped>
.collapsible {
    overflow: hidden;

    & .collapsible__body {
        box-sizing: content-box;
        padding-bottom: 20px;
        transition: 150ms ease-out;

        & >>> li {
            line-height: 1.4em;
        }

        & >>> ol {
            margin: 0 0 10px;
            padding-left: 20px;
        }

        & >>> p {
            margin: 0 0 10px;
        }

        & >>> ul {
            list-style: disc;
            margin: 0 0 10px;
            padding-left: 20px;
        }
    }

    & .collapsible__button {
        background: transparent;
        border: none;
        cursor: pointer;
        margin-top: -8px;
        padding: 0;
        position: absolute;
        right: 4px;
        top: 50%;
    }

    & .collapsible__header {
        cursor: pointer;
        padding: 20px 24px 20px 0;
        position: relative;

        & h2 {
            font-size: 18px;
            font-weight: normal;
            margin: 0;
        }
    }

    & .collapsible__icon {
        color: #6c7275;
        font-size: 18px;
    }
}
</style>
